import { RestGetVivaIsvConfig } from "../types/paymentMethods/vivaIsvConfig";

export const calculateVivaIsvFee = (
  saleAmountMinor: number,
  isvFee: RestGetVivaIsvConfig["isvFee"],
): number => {
  if (!isvFee) {
    return 0;
  }
  return (
    Math.round(saleAmountMinor * (isvFee.percentage / 100)) +
    isvFee.amount.amount
  );
};
